import { IonBadge } from "@ionic/react";

// `is_free_program` only reaches Team members (badge holders): the backend sets
// it for them alone (FreeProgramLabelService), from the FREE enrolment —
// preparation week included — until the program ends.
export const isOnFreeProgram = (user) => user?.is_free_program === true;

// "FREE" beside a member's name in posts and comments, in the blue of the FREE
// chip in the header.
const FreeProgramLabel = ({ user }) =>
  isOnFreeProgram(user) ? (
    <IonBadge
      className="free-program-label"
      style={{ "--background": "#0084b4", "--color": "#fff" }}
    >
      FREE
    </IonBadge>
  ) : null;

export default FreeProgramLabel;
